import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Details from "../views/Details.vue";
import Category from "../views/Category.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home Page - Inside Travel",
      metaTags: [
        {
          name: "description",
          content:
            "Home page of Inside Travel, providing travel industry's directory with easy search.",
        },
        {
          property: "og:description",
          content:
            "Home page of Inside Travel, providing travel industry's directory with easy search.",
        },
      ],
    },
    children: [
      {
        // Details will be rendered inside Home's <router-view>
        // when details/:type/:name is matched
        path: "details/:type/:name",
        component: Details,
        props: true,
        name: "Details",
      },
      {
        // Details will be rendered inside Home's <router-view>
        // cat/:cat/:name?tid=123
        path: "cat/:cat/:name",
        component: Category,
        name: "Category",
      },
      {
        path: "cookies",
        name: "Cookies",
        component: () =>
          import(/* webpackChunkName: "cookies" */ "../views/Cookies.vue"),
      },
      {
        path: "terms",
        name: "Terms",
        component: () =>
          import(/* webpackChunkName: "terms" */ "../views/Terms.vue"),
      },
      {
        path: "privacy",
        name: "Privacy",
        component: () =>
          import(/* webpackChunkName: "privacy" */ "../views/Privacy.vue"),
      },
      {
        path: "contact",
        name: "Contact",
        component: () =>
          import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
      },
      {
        path: "about",
        name: "About",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue"),
      },
      {
        path: "faq",
        name: "FAQ",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/FAQ.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Add webpage title and meta tags to each page
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
